import { WsButtonPrimary } from './workspace'
import { LIMIT_CARD_BODY, LIMIT_CARD_COPY, type LimitCardKind } from './planDisplay'

/** Shown in the result area when a translation is refused for the free allowance or length. */
export function LimitCard({ kind, onTryPro }: { kind: LimitCardKind; onTryPro: () => void }) {
  return (
    <div
      role="status"
      data-testid="limit-card"
      className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-3 px-4 py-3.5"
      style={{ borderRadius: 8, border: '1px solid var(--line)', background: 'var(--accent-soft)' }}
    >
      <div className="flex-1 min-w-[200px]" lang="en" dir="ltr">
        <p className="text-[15px] font-bold" style={{ color: 'var(--ink)' }}>{LIMIT_CARD_COPY[kind].title}</p>
        <p className="mt-1 text-[13px]" style={{ color: 'var(--muted)' }}>{LIMIT_CARD_BODY}</p>
      </div>
      <WsButtonPrimary className="h-11 shrink-0" onClick={onTryPro}>Try Pro Free</WsButtonPrimary>
    </div>
  )
}
